{
  "key": "archy.symbo.ls",
  "distDir": "smbls"
}